import isObject from './isObject'
import isArray from './isArray'
import reduce from './reduce'

const omitDeep = (object, keys) => {
  if (isArray(object)) {
    return object.map(val => omitDeep(val, keys))
  }

  if (isObject(object)) {
    return reduce(object, (res, key, val) => {
      if (isObject(val) || isArray(val)) {
        res[key] = omitDeep(val, keys)
      } else if (!keys.includes(key)) {
        res[key] = val
      }
    })
  }

  return object
}

export default omitDeep
